const OurStory = () => {
  return (
    <div className="w-full flex items-center justify-center">
      <div className="max-w-[1272px]">
        <div className="bg-textWhite py-2.5 px-5 lg:px-[54px]">
          <div className="py-10 lg:py-0 p-2.5 flex flex-col lg:flex-row items-center gap-6">
            <div className="w-full lg:w-1/2 flex flex-col gap-3.5">
              <h3 className="text-textBlack text-[36px] font-poppins font-semibold">
                Our Story
              </h3>
              <p className="whitespace-pre-line text-textBlack3 leading-[20px] tracking-[0%] font-poppins">
                For many Nigerians in the diaspora, investing in real estate
                back home has been a lot of hassle. Fraudulent agents, forged
                documents, inflated prices, and abandoned projects have cost
                diasporans their hard-earned savings and trust. Distance makes
                it worse. Without reliable structures in place, the dream of
                owning property in Nigeria feels risky, inaccessible, and
                uncertain.  Every year, thousands of diasporans delay their
                plans out of fear. Yet while they wait, property prices climb,
                opportunities vanish, and the vision of building back home
                drifts further out of reach.
              </p>
              <p className="whitespace-pre-line text-textBlack3 leading-[20px] tracking-[0%] font-poppins">
                Through engagement with the diasporan communities worldwide,
                listening to their experiences and identifying what a reliable
                system must deliver. The message was clear: Nigerians abroad
                needed a trusted structure backed by credible institutions to
                invest back home. 
              </p>
              <p className="whitespace-pre-line text-textBlack3 leading-[20px] tracking-[0%] font-poppins">
                From these engagements, the vision for{" "}
                <span className="font-bold">Home & Abroad</span> was born — a
                platform built to restore trust and provide a transparent
                pathway to property ownership in Nigeria. 
              </p>
              <p className="whitespace-pre-line text-textBlack3 leading-[20px] tracking-[0%] font-poppins">
                On <span className="font-bold">July 25th, 2025</span> at the
                State Banquet Hall of the Presidential Villa during{" "}
                <span className="font-bold">National Diaspora Day,</span>
                that vision became reality with the official launch of Home &
                Abroad. 
              </p>
            </div>
            <div className="w-full lg:w-1/2 gap-2 flex-col">
              <img
                src="/assets/images/about-us.png"
                className="w-full max-h-[433px]"
                alt=""
              />
              <p className="whitespace-pre-line text-textBlack3 text-sm p-1.5 leading-[20px] tracking-[0%] font-poppins">
                <span className="font-medium">On the Right:</span> L-R Hon Dr.
                Abike Dabiri Erewa Chairman CEO NIDCOM, Mr Olubunmi Tunji Hon.
                Minister of Interior, Mr Sidney Sampson, GMP/CEO Sydani Group,
                Madam Sarah David Alero, Diaspora FPO. FCT. <br />
                <span className="font-medium">On the Left:</span> Sen. George
                Akume Secretary General of the Federation and other dignitories.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurStory;
